import * as Types from '../../../actions/types'

export const storeTempLivdomDetails = (params) => {
    return dispatch => {
        dispatch({ type: Types.STORE_LIVDOM_DETAILS, livdom: params })
    }
}